import React from 'react'
import styled from 'styled-components'
import t from 'prop-types'

import { Button, Form } from 'components/UI'

const PasswordField = styled(Form.Text)`
  ${({error}) => error && 'border: solid 2px red;'}
`

class FirstLoginForm extends React.Component {
  state = {}

  onSubmit = event => {
    event.preventDefault()
    this.props.onSubmit({
      email: this.props.email,
      ...this.state,
    })
  }

  changeField (field, value) {
    this.setState({ [field]: value })
  }

  render () {
    const { email } = this.props
    const {
      password,
      passwordConfirm,
    } = this.state
    const passwordError = password !== passwordConfirm

    return (
      <form onSubmit={this.onSubmit}>
        Account not active. Please create a new password and fill in your details.
        <Form.Text
          big
          value={email}
          placeholder='Email'
          disabled
        />
        <Form.Text
          big
          value={this.state.givenName}
          onChange={value => this.changeField('givenName', value)}
          placeholder='First Name'
        />
        <Form.Text
          big
          value={this.state.familyName}
          onChange={value => this.changeField('familyName', value)}
          placeholder='Last Name'
        />
        <Form.Text
          big
          value={this.state.phoneNumber}
          onChange={value => this.changeField('phoneNumber', value)}
          placeholder='Phone Number'
        />
        <Form.Text
          big
          type='password'
          value={this.state.password}
          onChange={value => this.changeField('password', value)}
          placeholder='Password'
        />
        <PasswordField
          big
          type='password'
          value={this.state.passwordConfirm}
          onChange={value => this.changeField('passwordConfirm', value)}
          placeholder='Password Confirmation'
          error={passwordError}
        />

        <Button
          fluid
          big
          disabled={passwordError}
        >
          Activate Account
        </Button>
      </form>
    )
  }
}

FirstLoginForm.propTypes = {
  onSubmit: t.func.isRequired,
  email: t.string.isRequired,
}

export default FirstLoginForm



// WEBPACK FOOTER //
// ./src/components/Login/FirstLoginForm.jsx